/**
 * @generated SignedSource<<6d7567a242d602ed8be6d5b67bddf8e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "enquiry",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EnquiryWizardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EnquiryWizardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e496d5862563fc55999784b9bfd7f7f1",
    "id": null,
    "metadata": {},
    "name": "EnquiryWizardMutation",
    "operationKind": "mutation",
    "text": "mutation EnquiryWizardMutation(\n  $input: EnquiryInput!\n) {\n  enquiry(input: $input)\n}\n"
  }
};
})();

node.hash = "3e6c6cbd499aabdc589d4f22f51629cd";

module.exports = node;
